var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Vip-Good-list',{attrs:{"good-list":_vm.bastList,"is-sort":false}})}
var staticRenderFns = []

export { render, staticRenderFns }